<template>
  <div>
    <div
      v-if="messages.length!==0"
      class="alert show"
    >
      <ul>
        <li
          v-for="(msg,index) in messages"
          :key="'key-'+index"
        >
          <div v-html="msg" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      messages: [],
      bgColor: ''
    }
  },
  methods: {
    notify (msg) {
      this.messages.push(msg)
      setTimeout(() => {
        if (this.messages.length && this.messages[0] === msg) {
          this.messages.shift()
        }
      }, 2000)
    }
  }
}
</script>

<style lang="stylus" scoped>
.alert
  transform translate(-50%, -100%)
  left 50%
  top 50%
  position fixed
  text-align center
  margin auto
  z-index 9999999
li
  font-size 0.3rem
  color #fff
  font-weight normal
  background-color rgba(0, 0, 0, 0.75)
  margin 0.1rem auto
  border-radius 0.2rem
  padding 0.2rem 0.4rem
  animation animateFade 0.5s ease both
@keyframes animateFade
  from
    opacity 0.3
    -webkit-transform translate3d(0, -20%, 0)
    transform translate3d(0, -20%, 0)
  to
    opacity 1
    -webkit-transform translate3d(0, 0, 0)
    transform translate3d(0, 0, 0)
</style>
